module.exports = global["toastr"] = require("-!./toastr.js");